import React from 'react';
import getButtons from '../Utils/getButtons';
import { useModalState } from '../Hooks';
import styled from "styled-components";


const StyledFooter = styled.div`
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-top: 16px;
      .mdn-Modal-footer {
      flex-wrap: wrap;
    }
    button {
      margin: 0 8px 8px 0;
    }
`;

const ModalFooter = ({ closeModal, disableFooterButton, disableCloseButton, buttons, props }) => {

  const { history, dispatch, handleNext } = useModalState();

  return (
    <StyledFooter>
      {getButtons({ closeModal, disableFooterButton, disableCloseButton, props, history, dispatch, handleNext, buttons })}
    </StyledFooter>
  )
};

export default ModalFooter;
